<!--
 * @Date: 2023-12-13 16:30:29
 * @Author: jm
 * @LastEditTime: 2024-02-28 10:44:24
 * @LastEditors: jm
 * @FilePath: \funny_h5\src\components\CustomHeader.vue
 * @Description: 
-->
<template>
  <div class="classification">
    <a
      class="classification-item"
      v-for="(item, index) in imageList"
      :key="index"
      :href="item.path"
    >
      <div class="classification-itemImg">
        <img :src="item.typeLogo" alt="" />
      </div>
      <p class="classification-text">{{ item.type }}</p>
    </a>
  </div>
</template>

<script>
import image1 from "@/assets/images/type/image1.png";
import image2 from "@/assets/images/type/image2.png";
import image3 from "@/assets/images/type/image3.png";
import image4 from "@/assets/images/type/image4.png";
import image5 from "@/assets/images/type/image5.png";
import image6 from "@/assets/images/type/image6.png";
import image7 from "@/assets/images/type/image7.png";
import image8 from "@/assets/images/type/image8.png";
import image9 from "@/assets/images/type/image9.png";
import image10 from "@/assets/images/type/image10.png";
export default {
  name: "CustomHeader",
  data() {
    return {
      imageList: [
        {
          typeLogo: image1,
          type: "Pakour",
          path: "type.html?type=Pakour",
        },
        { typeLogo: image2, type: "Shooting", path: "type.html?type=Shooting" },
        { typeLogo: image3, type: "Girls", path: "type.html?type=Girls" },
        { typeLogo: image4, type: "Racing", path: "type.html?type=Racing" },
        { typeLogo: image5, type: "Cards", path: "type.html?type=Cards" },
        { typeLogo: image6, type: "Casual", path: "type.html?type=Casual" },
        { typeLogo: image7, type: "Puzzle", path: "type.html?type=Puzzle" },
        { typeLogo: image8, type: "Sport", path: "type.html?type=Sport" },
        { typeLogo: image9, type: "Action", path: "type.html?type=Action" },
        { typeLogo: image10, type: "Match3", path: "type.html?type=Match3" },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.classification {
  width: 1040px;
  margin: 0px auto 0px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  .classification-item {
    width: 150px;
    padding: 0px 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .classification-itemImg {
      width: 175px;
      height: 175px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .classification-text {
      margin: 41px 0px;
      font-size: 30px;
      font-weight: 500;
      font-weight: normal;
      color: #ffffff;
    }
  }
}
</style>
